import { render, staticRenderFns } from "./CallScreen.vue?vue&type=template&id=5ac2d61c"
import script from "./CallScreen.vue?vue&type=script&lang=js"
export * from "./CallScreen.vue?vue&type=script&lang=js"
import style0 from "./CallScreen.vue?vue&type=style&index=0&id=5ac2d61c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports